<template>
  <div>
    <!-- Filter Start -->
    <custom-filter :getFilterOnStart="true" @filterChange="changeFilter"></custom-filter>
    <!-- Filter End -->

    <!-- Chart Start -->
    <div class="row mt-4">
      <div class="col">
        <div class="innerBox">
          <div class="row">
            <div class="col-md-8">
              <h5 class="elegant--sub-title">
                Activation Report
                <!-- <i class="far fa-info-circle" id="activation-report"></i> -->
                <svg id="activation-report" width="14" height="14" viewBox="0 0 14 14" fill="none"
                  xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M6.04729 4.10352C6.04729 3.74716 6.33885 3.45559 6.69521 3.45559H7.12716C7.48352 3.45559 7.77508 3.74716 7.77508 4.10352V4.53546C7.77508 4.89182 7.48352 5.18339 7.12716 5.18339H6.69521C6.33885 5.18339 6.04729 4.89182 6.04729 4.53546V4.10352ZM8.63898 10.3668H5.18339V9.50288H6.04729V6.91118H5.18339V6.04729H7.77508V9.50288H8.63898L8.63898 10.3668ZM6.91118 3.57628e-07C3.09424 3.57628e-07 0 3.09424 0 6.91118C0 10.7281 3.09424 13.8224 6.91118 13.8224C10.7281 13.8224 13.8224 10.7281 13.8224 6.91118C13.8224 3.09424 10.7281 3.57628e-07 6.91118 3.57628e-07ZM6.91118 12.5265C3.80992 12.5265 1.29585 10.0124 1.29585 6.91118C1.29585 3.80992 3.80992 1.29585 6.91118 1.29585C10.0124 1.29585 12.5265 3.80992 12.5265 6.91118C12.5265 10.0124 10.0124 12.5265 6.91118 12.5265Z"
                    fill="#D1D1D1" />
                </svg>
                <b-popover target="activation-report" triggers="hover" placement="top">
                  <template #title>Activation Report</template>
                  <div v-html="tooltip.activation_report"></div>
                </b-popover>
              </h5>
            </div>
            <div class="col-md-2">
              <MultiSelect v-model="filter.oilmaker" :options="options.oilMaker.map((x) => x.code)" :custom-label="(opt) => options.oilMaker.find((x) => x.code == opt).title
                " :select-label="''" placeholder="All Oil Makers" class="elegant-multiselect" />
            </div>
            <div class="col-md-2">
              <button class="btn btn-elegant-download" @click="
                exportExcel(
                  data.activationReportChart,
                  'Activation Report Oil Maker Download'
                )
                ">
                 Download Excel <img src="@/assets/Group 1745.svg" alt="View Map"
                       style="width: 14px; height: 14px; cursor: pointer; margin-left: 16px; position: relative; top: -2px;"/>
              </button>
            </div>
          </div>
          <activation-report-chart v-if="data.activationReportChart" :data="data.activationReportChart"
            :filter="filter"></activation-report-chart>
          <div v-else class="text-center mt-5 mb-5">
            <h2 class="pt-5 pb-5">Loading...</h2>
          </div>
        </div>
      </div>
    </div>
    <!-- Chart End -->

    <div class="innerBox mt-4">
      <div class="row">
        <div class="col-md-10">
          <h5 class="elegant--sub-title">
            Report by Purchase Order
            <!-- <i class="far fa-info-circle" id="history-report"></i> -->
            <svg id="report-by-purchase-order" width="14" height="14" viewBox="0 0 14 14" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.04729 4.10352C6.04729 3.74716 6.33885 3.45559 6.69521 3.45559H7.12716C7.48352 3.45559 7.77508 3.74716 7.77508 4.10352V4.53546C7.77508 4.89182 7.48352 5.18339 7.12716 5.18339H6.69521C6.33885 5.18339 6.04729 4.89182 6.04729 4.53546V4.10352ZM8.63898 10.3668H5.18339V9.50288H6.04729V6.91118H5.18339V6.04729H7.77508V9.50288H8.63898L8.63898 10.3668ZM6.91118 3.57628e-07C3.09424 3.57628e-07 0 3.09424 0 6.91118C0 10.7281 3.09424 13.8224 6.91118 13.8224C10.7281 13.8224 13.8224 10.7281 13.8224 6.91118C13.8224 3.09424 10.7281 3.57628e-07 6.91118 3.57628e-07ZM6.91118 12.5265C3.80992 12.5265 1.29585 10.0124 1.29585 6.91118C1.29585 3.80992 3.80992 1.29585 6.91118 1.29585C10.0124 1.29585 12.5265 3.80992 12.5265 6.91118C12.5265 10.0124 10.0124 12.5265 6.91118 12.5265Z"
                fill="#D1D1D1" />
            </svg>
            <b-popover target="report-by-purchase-order" triggers="hover" placement="top">
              <template #title>Report by Purchase Order</template>
              <div v-html="tooltipOilMaker"></div>
            </b-popover>
          </h5>
        </div>
        <div class="col-md-2">
          <button @click="
            downloadReportbyPOExcel(
              data.reportByPo,
              'Report by Purchase Order Download'
            )
            " class="btn btn-elegant-download">
             Download Excel <img src="@/assets/Group 1745.svg" alt="View Map"
              style="width: 14px; height: 14px; cursor: pointer; margin-left: 16px; position: relative; top: -2px;"/>
          </button>
        </div>
      </div>

      <div class="scan-history-table-wrapper mt-3">
        <div v-if="!data.reportByPo" class="text-center mt-3 mb-3">
          <h4>Loading...</h4>
        </div>
        <div v-else style="overflow-x: auto; overflow-y: hidden">
          <table class="table scan-history-table po-report-table" style="margin: 0">
            <thead>
              <tr>
                <th rowspan="2" scope="col">No PO</th>
                <th rowspan="2" scope="col">Label Maker</th>
                <th rowspan="2" scope="col">PO Date</th>
                <th rowspan="2" scope="col">Variant</th>
                <th colspan="5" class="text-center" scope="colgroup">Total</th>
              </tr>
              <tr>
                <th scope="col">QR</th>
                <th scope="col">Spare</th>
                <th scope="col">Scan</th>
                <th scope="col">Activate</th>
                <th scope="col">Failed</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in reportByPoRows" :key="row.key">
                <td>{{ row.showMeta ? row.poItem.no_po || "-" : "" }}</td>
                <td>{{ row.showMeta ? row.poItem.label_maker || "-" : "" }}</td>
                <td>{{ row.showMeta ? formatPoDate(row.poItem.po_date) : "" }}</td>
                <td>{{ row.contentItem.variant || "-" }}</td>
                <td>{{ formatNumber(row.contentItem.qr_total) }}</td>
                <td>{{ formatNumber(row.contentItem.spare_total) }}</td>
                <td>{{ formatNumber(row.contentItem.scan_total) }}</td>
                <td>{{ formatNumber(row.contentItem.activate) }}</td>
                <td>{{ formatNumber(row.contentItem.failed) }}</td>
              </tr>
              <tr v-if="reportByPoRows.length === 0">
                <td colspan="9" class="text-center">No data available</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- Table Start -->
    <div class="bg-white shadow box-content mt-5">
      <div class="row">
        <div class="col-md-10">
          <h5 class="elegant--sub-title">
            History Report
            <!-- <i class="far fa-info-circle" id="history-report"></i> -->
            <svg id="history-report" width="14" height="14" viewBox="0 0 14 14" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <path
                d="M6.04729 4.10352C6.04729 3.74716 6.33885 3.45559 6.69521 3.45559H7.12716C7.48352 3.45559 7.77508 3.74716 7.77508 4.10352V4.53546C7.77508 4.89182 7.48352 5.18339 7.12716 5.18339H6.69521C6.33885 5.18339 6.04729 4.89182 6.04729 4.53546V4.10352ZM8.63898 10.3668H5.18339V9.50288H6.04729V6.91118H5.18339V6.04729H7.77508V9.50288H8.63898L8.63898 10.3668ZM6.91118 3.57628e-07C3.09424 3.57628e-07 0 3.09424 0 6.91118C0 10.7281 3.09424 13.8224 6.91118 13.8224C10.7281 13.8224 13.8224 10.7281 13.8224 6.91118C13.8224 3.09424 10.7281 3.57628e-07 6.91118 3.57628e-07ZM6.91118 12.5265C3.80992 12.5265 1.29585 10.0124 1.29585 6.91118C1.29585 3.80992 3.80992 1.29585 6.91118 1.29585C10.0124 1.29585 12.5265 3.80992 12.5265 6.91118C12.5265 10.0124 10.0124 12.5265 6.91118 12.5265Z"
                fill="#D1D1D1" />
            </svg>
            <b-popover target="history-report" triggers="hover" placement="top">
              <template #title>History Report</template>
              <div v-html="tooltip.history_report"></div>
            </b-popover>
          </h5>
        </div>
        <div class="col-md-2">
          <button @click="downloadReportHistoryExcel" class="btn btn-elegant-download">
             Download Excel <img src="@/assets/Group 1745.svg" alt="View Map"
                       style="width: 14px; height: 14px; cursor: pointer; margin-left: 16px; position: relative; top: -2px;"/>
          </button>
        </div>
      </div>

      <div class="mt-3 scan-history-table-wrapper">
        <div v-if="historyTable.loading" class="text-center mt-3 mb-3">
          <h4>Loading...</h4>
        </div>

        <div v-else style="overflow-x: auto; overflow-y: hidden">
          <table class="table scan-history-table" style="margin: 0">
            <thead>
              <tr>
                <th>Variant</th>
                <th>Volume</th>
                <th>Kode QR</th>
                <th>Status</th>
                <th>Oil Maker</th>
                <th>Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in historyTable.data" :key="index">
                <td>{{ row.product_name }}</td>
                <td>{{ row.volume }}</td>
                <td>{{ row.qrcode }}</td>
                <td :style="getStatusStyle(row.status)">{{ row.status }}</td>
                <td>{{ row.oil_maker }}</td>
                <td>{{ row.scan_date }}</td>
              </tr>
              <tr v-if="!historyTable.loading && historyTable.data.length === 0">
                <td colspan="6" class="text-center">No data available</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="row mt-3"
          v-if="!historyTable.loading && (historyTable.data.length > 0 || historyTable.maxPage > 0)">
          <div class="col-12 d-flex align-items-center justify-content-between flex-wrap">
            <div class="d-flex align-items-center">
              <label for="history-view-items-per-page"
                style="margin-right: 8px; margin-bottom: 0; color: #a3a4a6; font-size: 14px;">View</label>
              <select id="history-view-items-per-page" v-model.number="historyTable.limit" @change="onHistoryLimitChange"
                class="form-control form-control-sm" style="width: auto; display: inline-block; padding: 4px 8px;">
                <option :value="10">10</option>
                <option :value="25">25</option>
                <option :value="50">50</option>
                <option :value="100">100</option>
              </select>
              <span style="margin-left: 8px; color: #a3a4a6; font-size: 14px;">items per page</span>
            </div>
            <div class="d-flex align-items-center flex-wrap">
              <p class="mt-2 mb-2" style="color: #a3a4a6; margin-right: 20px; margin-bottom: 0;">
                Showing
                {{
                  historyDisplayRange.start
                }}-{{ historyDisplayRange.end }} of {{ historyTable.total || "?" }} Items
              </p>
              <nav class="pagination-minimal">
                <ul class="pagination" style="margin: 0; flex-wrap: wrap;">
                  <li class="page-item" :class="{ disabled: historyTable.currentPage <= 1 }"
                    @click.stop.prevent="changeHistoryPage('prev')">
                    <a class="page-link" href="javascript:void(0)">&lsaquo;</a>
                  </li>
                  <li class="page-item" :class="{
                    disabled:
                      historyTable.currentPage >= historyTable.maxPage && !historyHasMoreData,
                  }" @click.stop.prevent="changeHistoryPage('next')">
                    <a class="page-link" href="javascript:void(0)">&rsaquo;</a>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Table End -->
  </div>
</template>

<script>
import qs from "qs";
import * as XLSX from "xlsx";
import moment from "moment";
import customFilter from "@/components/filter/customFilter";
// import highlightStats from './children/HighlightStats'

import activationReportChart from "./children/activationReportChart.vue";

export default {
  metaInfo: {
    title: "Report - Oil Maker",
  },
  data() {
    return {
      tooltip: this.$store.state.tooltip.reports,
      tooltipOilMaker: '<span>Data report yang dikelompokkan berdasarkan nomor Purchase Order</span>',
      filter: {
        oilmaker: null,
      },
      data: {
        activationReportChart: null,
        reportByPo: null,
      },
      options: {
        oilMaker: this.$store.getters.getOilMaker,
      },
      historyTable: {
        data: [],
        loading: false,
        currentPage: 1,
        maxPage: 1,
        total: 0,
        limit: 10,
        fetchTimer: null,
      },
    };
  },
  components: {
    customFilter,
    // highlightStats,

    activationReportChart,
  },
  mounted() {
    this.fetchData();
  },
  beforeDestroy() {
    if (this.historyTable.fetchTimer) {
      clearTimeout(this.historyTable.fetchTimer);
    }
  },
  watch: {
    filter: {
      deep: true,
      handler: "fetchData",
    },
  },
  methods: {
    downloadReportHistoryExcel() {
      const filterlessFilter = { ...this.filter };
      delete filterlessFilter.filter;
      this.$http
        .get(
          `/api/reports/oilmaker-history?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((response) => {
          const wb = XLSX.utils.book_new();
          const exportFileName = "Exported Data.xlsx";

          const ws = XLSX.utils.json_to_sheet(response.data.data, { raw: true });
          XLSX.utils.book_append_sheet(wb, ws, "Data");
          XLSX.writeFile(wb, exportFileName);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeFilter(filter) {
      for (const key of Object.keys(filter)) {
        this.$set(this.filter, key, filter[key]);
      }

      this.historyTable.currentPage = 1;
      this.fetchData();
    },
    fetchData() {
      // Reset All Data to null
      for (const key of Object.keys(this.data)) {
        this.$set(this.data, key, null);
      }

      // Remove filter from filter
      const filterlessFilter = { ...this.filter };
      delete filterlessFilter.filter;

      //Get Activation Report
      this.$http
        .get(
          `/api/reports/oilmaker-activity?${qs.stringify(this.filter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          this.data.activationReportChart = resp.data.data;
        })
        .catch((err) => {
          console.log(err);
        });

      //Get Report By PO Order
      this.$http
        .get(
          `/api/reports/oilmaker-po-report?${qs.stringify(filterlessFilter, {
            skipNulls: true,
            arrayFormat: "comma",
          })}`
        )
        .then((resp) => {
          this.data.reportByPo = resp.data.data;
        })
        .catch((err) => {
          console.log(err);
        });

      this.fetchHistoryData();
    },
    downloadReportbyPOExcel(data, title) {
      const wb = XLSX.utils.book_new();
      const exportFileName = title ? `${title}.xlsx` : "Exported Data.xlsx";

      const flattenedData = [];

      for (const item of data) {
        for (const contentItem of item.content) {
          flattenedData.push({
            no_po: item.no_po,
            po_date: item.po_date,
            variant: contentItem.variant,
            qr_total: contentItem.qr_total,
            spare_total: contentItem.spare_total,
            scan_total: contentItem.scan_total,
            failed: contentItem.failed,
            activate: contentItem.activate,
          });
        }
      }

      const ws = XLSX.utils.json_to_sheet(flattenedData, { raw: true });
      XLSX.utils.book_append_sheet(wb, ws, "Data");
      XLSX.writeFile(wb, exportFileName);
    },
    fetchHistoryData() {
      if (this.historyTable.fetchTimer) {
        clearTimeout(this.historyTable.fetchTimer);
      }

      this.historyTable.fetchTimer = setTimeout(() => {
        this.performFetchHistoryData();
      }, 300);
    },
    async performFetchHistoryData() {
      this.historyTable.loading = true;

      try {
        let queryParams = {
          pagination: true,
          limit: this.historyTable.limit,
          page: this.historyTable.currentPage,
          order: "DESC",
          by: "scan_date",
        };

        const queryFilter = { ...this.filter };
        delete queryFilter.filter;

        const url = `/api/reports/oilmaker-history?${qs.stringify(
          { ...queryParams, ...queryFilter },
          {
            skipNulls: true,
            arrayFormat: "comma",
          }
        )}`;

        const resp = await this.$http.get(url);
        const rawData = resp.data.data || [];
        const meta = resp.data.meta || resp.data.pagination || resp.data || {};

        const processedData = rawData.map((item) => ({
          product_name: item.product_name ? item.product_name : "-",
          volume: item.volume ? Number.parseInt(item.volume, 10) / 1000 + " Lt" : "-",
          qrcode: item.qrcode ? item.qrcode : "-",
          status: item.status ? item.status : "-",
          oil_maker: item.oil_maker ? item.oil_maker : "-",
          scan_date: item.scan_date ? item.scan_date : "-",
        }));

        this.$set(this.historyTable, "data", processedData);

        const currentPage =
          meta.currentPage ||
          meta.current_page ||
          meta.page ||
          this.historyTable.currentPage ||
          1;
        let total =
          meta.total ||
          meta.totalItems ||
          meta.total_count ||
          meta.totalRecords ||
          meta.count ||
          0;
        let lastPage =
          meta.lastPage ||
          meta.last_page ||
          meta.totalPages ||
          meta.total_pages ||
          meta.maxPage ||
          0;

        if (total === 0) {
          if (processedData.length === this.historyTable.limit) {
            total = this.historyTable.currentPage * this.historyTable.limit;
            lastPage = this.historyTable.currentPage + 1;
          } else if (processedData.length > 0) {
            total =
              (this.historyTable.currentPage - 1) * this.historyTable.limit +
              processedData.length;
            lastPage = this.historyTable.currentPage;
          } else {
            total = 0;
            lastPage = 1;
          }
        } else if (total > 0) {
          if (!lastPage || lastPage === 0) {
            lastPage = Math.ceil(total / this.historyTable.limit);
          }
        }

        lastPage = Math.max(1, lastPage);

        if (
          processedData.length === this.historyTable.limit &&
          this.historyTable.currentPage >= lastPage
        ) {
          lastPage = this.historyTable.currentPage + 1;
        }

        this.$set(this.historyTable, "currentPage", Number.parseInt(currentPage));
        this.$set(this.historyTable, "maxPage", Number.parseInt(lastPage));
        this.$set(this.historyTable, "total", Number.parseInt(total));
      } catch (err) {
        console.log("Error fetching oil maker history data:", err);
        this.$set(this.historyTable, "data", []);
        this.$set(this.historyTable, "currentPage", 1);
        this.$set(this.historyTable, "maxPage", 1);
        this.$set(this.historyTable, "total", 0);
      } finally {
        this.historyTable.loading = false;
      }
    },
    onHistoryLimitChange() {
      this.$set(this.historyTable, "currentPage", 1);
      this.fetchHistoryData();
    },
    changeHistoryPage(opt) {
      if (this.historyTable.loading) {
        return;
      }

      let newPage = this.historyTable.currentPage;

      if (opt === "prev") {
        newPage = Math.max(1, this.historyTable.currentPage - 1);
      } else if (opt === "next") {
        if (
          this.historyHasMoreData ||
          this.historyTable.currentPage < this.historyTable.maxPage
        ) {
          newPage = this.historyTable.currentPage + 1;
        } else {
          return;
        }
      }

      if (newPage !== this.historyTable.currentPage && newPage >= 1) {
        this.$set(this.historyTable, "currentPage", newPage);
        this.fetchHistoryData();
      }
    },
    getStatusStyle(status) {
      const styles = {
        ACTIVATE: "color:green; font-weight:bold",
        DEACTIVATE: "color:red; font-weight:bold",
        "Double Scan": "color:orange; font-weight:bold",
      };
      return styles[status] || "";
    },
    formatNumber(value) {
      if (value === null || value === undefined || value === "") {
        return "0";
      }
      const numberValue = Number(value);
      if (Number.isNaN(numberValue)) {
        return "0";
      }
      return numberValue.toLocaleString("en-US");
    },
    formatPoDate(date) {
      if (!date) {
        return "-";
      }
      return moment(date).format("DD MMM YYYY HH:mm:ss");
    },
  },
  computed: {
    reportByPoRows() {
      if (!Array.isArray(this.data.reportByPo)) {
        return [];
      }

      const rows = [];

      for (let poIndex = 0; poIndex < this.data.reportByPo.length; poIndex += 1) {
        const poItem = this.data.reportByPo[poIndex];
        const contents = Array.isArray(poItem.content) ? poItem.content : [];

        for (let contentIndex = 0; contentIndex < contents.length; contentIndex += 1) {
          const contentItem = contents[contentIndex];
          rows.push({
            key: `${poIndex}-${contentIndex}`,
            poItem,
            contentItem,
            showMeta: contentIndex === 0,
          });
        }
      }

      return rows;
    },
    historyHasMoreData() {
      return this.historyTable.data.length === this.historyTable.limit;
    },
    historyDisplayRange() {
      if (!this.historyTable.data.length) {
        return { start: 0, end: 0 };
      }

      const start = (this.historyTable.currentPage - 1) * this.historyTable.limit + 1;
      const endCandidate = this.historyTable.currentPage * this.historyTable.limit;
      const total =
        this.historyTable.total && this.historyTable.total > 0
          ? this.historyTable.total
          : start + this.historyTable.data.length - 1;

      return {
        start,
        end: Math.min(endCandidate, total),
      };
    },
  },
};
</script>

<style scoped>
.btn-elegant-download {
  font-weight: 500 !important;
}
.innerBox {
  background-color: white;
  border-radius: 8px;
  box-shadow: 0px 3px 10px #0000000f;
  padding: 20px;
}

.elegant--sub-title {
  font-size: 18px;
  font-weight: 500;
  color: #9f9f9f;
}

.table td,
.table th {
  text-align: center;
}

.box-content {
  padding: 20px;
  border-radius: 10px;
}

/* Scan History Table Styles */
.scan-history-table-wrapper .scan-history-table {
  border-collapse: separate;
  border-spacing: 0;
  border: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr {
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr {
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table.table-striped tbody tr:nth-of-type(odd) {
  background-color: #ffffff !important;
}

.scan-history-table-wrapper .scan-history-table thead th {
  color: #9d9d9d;
  text-align: left;
  vertical-align: middle;
  border-bottom: 1px solid #dee2e6;
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table thead th:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td {
  color: #4b4b4b;
  text-align: left;
  vertical-align: middle;
  background-color: #ffffff !important;
  border-top: none !important;
  border-bottom: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:first-child {
  border-left: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody td:last-child {
  border-right: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:first-child td {
  border-top: none !important;
}

.scan-history-table-wrapper .scan-history-table tbody tr:last-child td {
  border-bottom: none !important;
}

.scan-history-table-wrapper .po-report-table tbody {
  display: block;
  max-height: 65vh;
  overflow-y: auto;
}

.scan-history-table-wrapper .po-report-table thead,
.scan-history-table-wrapper .po-report-table tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}

.scan-history-table-wrapper .po-report-table thead {
  width: calc(100% - 10px);
}

.scan-history-table-wrapper .po-report-table tbody::-webkit-scrollbar {
  width: 10px;
}

.scan-history-table-wrapper .po-report-table tbody::-webkit-scrollbar-track {
  background-color: white;
  border-radius: 20px;
}

.scan-history-table-wrapper .po-report-table tbody::-webkit-scrollbar-thumb {
  background-color: #f1f1f1;
  border-radius: 20px;
}

.scan-history-table-wrapper .po-report-table tbody::-webkit-scrollbar-thumb:hover {
  background-color: #d1d1d1;
}

/* Pagination Styles - Minimalist */
.scan-history-table-wrapper .pagination-minimal .pagination {
  margin-bottom: 0;
}

.scan-history-table-wrapper .pagination-minimal .page-item {
  margin: 0 2px;
}

.scan-history-table-wrapper .pagination-minimal .page-item .page-link {
  background: transparent !important;
  border: none !important;
  color: #4b4b4b;
  padding: 4px 8px;
  cursor: pointer;
  user-select: none;
  font-size: 14px;
}

.scan-history-table-wrapper .pagination-minimal .page-item:not(.disabled):hover .page-link {
  background: transparent !important;
  color: #007bff;
}

.scan-history-table-wrapper .pagination-minimal .page-item.disabled .page-link {
  cursor: not-allowed;
  pointer-events: none;
  opacity: 0.4;
  color: #9d9d9d !important;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link {
  background: transparent !important;
  border: none !important;
  color: #007bff !important;
  font-weight: 600;
}

.scan-history-table-wrapper .pagination-minimal .page-item.active .page-link:hover {
  background: transparent !important;
  color: #007bff !important;
}

:deep(.popover-header) {
  background-color: #ffffff;
  border-bottom: none;
  font-weight: 600;
  font-size: 12px;
  color: #111111;
}

:deep(.popover-body) {
  background-color: #ffffff;
  font-weight: 400;
  font-size: 12px;
  color: #9d9d9d;
}
:deep(.elegant-multiselect .multiselect__placeholder),
:deep(.elegant-multiselect .multiselect__single) {
  font-size: 12px !important;
  font-weight: 500 !important;
  color: #707070 !important;
}

:deep(.variant-select .multiselect__placeholder),
:deep(.variant-select .multiselect__single) {
  font-weight: 600 !important;
  color: #2D2D2D !important;
}
</style>
<style>
.elegant-multiselect .multiselect__placeholder {
  font-weight: 500 !important;
  font-size: 12px !important;
  color: #2D2D2D !important;
}
.elegant-flatpickr {
  font-weight: 600 !important;
  font-size: 12px !important;
}
</style>